import { render, staticRenderFns } from "./VasionCheckbox.vue?vue&type=template&id=14354b70&scoped=true&"
import script from "./VasionCheckbox.vue?vue&type=script&lang=js&"
export * from "./VasionCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./VasionCheckbox.vue?vue&type=style&index=0&id=14354b70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14354b70",
  null
  
)

export default component.exports